import { Spin } from "antd";
import HeaderList from "../../HeaderList";
import BodyList from "../../BodyList";
import { useIntl } from "react-intl";
import Empty from "../../../common/Empty";

const GiftCards = ({ data, setPage, page, isLoading }: any) => {
  const intl = useIntl();

  const cols = [
    intl.formatMessage({
      id: "number",
      defaultMessage: "#",
    }),
    intl.formatMessage({
      id: "status",
      defaultMessage: "Operation Date",
    }),
    intl.formatMessage({
      id: "total",
      defaultMessage: "Operation Status",
    }),
    intl.formatMessage({
      id: "clientName",
      defaultMessage: "Branch",
    }),
    intl.formatMessage({
      id: "start_date",
      defaultMessage: "Client",
    }),
    intl.formatMessage({
      id: "end_date",
      defaultMessage: "Channel",
    }),
  ];
  console.log(data);
  return isLoading ? (
    <Spin className="flex items-center justify-center my-4" />
  ) : data?.length ? (
    <div className="overflow-auto">
      <HeaderList cols={cols} />
      <BodyList
        data={data} // Assuming data.data is the correct data array
        page={page}
        setPage={setPage}
        isLoading={isLoading}
      />
    </div>
  ) : (
    <Empty
      title={intl.formatMessage({ id: "no_gift_cards" })}
      subTitle={intl.formatMessage({ id: "add_gift_cards_now" })}
    />
  );
};

export default GiftCards;
